/**
 * Game ID Constants
 * Centralized location for all game identifiers used across the application
 */

// Matka Game IDs
export const MATKA_LIVE_GAME_ID = "lgame0101";
export const MATKA_FUN_GAME_ID = "rgame0201";

// Game Provider
export const DEFAULT_GAME_PROVIDER = "RG01";

// Game Info Format: gameId:sportId:tgProviderId:provider:subProvider:type:category:tableId:gameLock:sectionLock
export const createGameInfo = (
  gameId: string,
  sportId: string = gameId,
  tgProviderId: string = DEFAULT_GAME_PROVIDER,
  provider: string = "",
  subProvider: string = "",
  type: string = "",
  category: string = "",
  tableId: string = "",
  gameLock: string = "false",
  sectionLock: string = "false"
): string => {
  return `${gameId}:${sportId}:${tgProviderId}:${provider}:${subProvider}:${type}:${category}:${tableId}:${gameLock}:${sectionLock}`;
};

// Default game info for Matka Live
export const DEFAULT_MATKA_LIVE_GAME_INFO = createGameInfo(
  MATKA_LIVE_GAME_ID,
  MATKA_LIVE_GAME_ID,
  DEFAULT_GAME_PROVIDER
);

// Default game info for Matka Fun
export const DEFAULT_MATKA_FUN_GAME_INFO = createGameInfo(
  MATKA_FUN_GAME_ID,
  MATKA_FUN_GAME_ID,
  DEFAULT_GAME_PROVIDER
);

